import IconButton from '@/global/components/Button/IconButton'
import Menu from '@/global/components/MenuV2'
import { Alert, Divider } from '@mui/material'
import Grid from '@mui/material/Grid'
import dayjs from 'dayjs'
import { FormField } from 'global/components/Form'
import { SelectFuncionario } from 'global/components/Selects'
import { ArrowRightLeftIcon, XIcon } from 'lucide-react'
import { useFormContext } from 'react-hook-form'
import { tabelaHorarios, TrocaDiaTrabalho } from 'service/api'

interface IProps {
    /** Desabilita o SelectEmpresa e SelectFuncionario */
    disableSelects?: boolean
    /** Desabilita o botão alterar dia */
    disabled?: boolean
}

export function FormTrocaDiaTrabalho({ disableSelects, disabled }: IProps) {
    const { watch, setValue, getValues } = useFormContext<TrocaDiaTrabalho>()

    const { tabelaHorarioId, trabalha, folga } = watch()

    const { data = [] } = tabelaHorarios.useFetch()

    return (
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <SelectFuncionario
                    size="medium"
                    disabled={disableSelects}
                    width="100%"
                    ativos
                />
            </Grid>
            <Divider className="w-full mt-4 select-none">
                Detalhes da troca
            </Divider>
            <Grid item xs={5}>
                <FormField
                    type="date"
                    name="trabalha"
                    label="Dia de trabalho"
                    required
                    InputProps={{
                        startAdornment: trabalha ? (
                            <span className="-mb-[18px]">
                                {dayjs.utc(trabalha).format('ddd')},&nbsp;
                            </span>
                        ) : null,
                    }}
                />
            </Grid>
            <Grid item xs={2} className="flex justify-center items-center">
                <IconButton
                    title="Trocar dias"
                    onClick={() => {
                        const trabalha = getValues('trabalha')
                        const folga = getValues('folga')
                        setValue('trabalha', folga)
                        setValue('folga', trabalha)
                    }}
                    className="mb-5"
                    disabled={disabled}
                >
                    <ArrowRightLeftIcon className="size-8" />
                </IconButton>
            </Grid>
            <Grid item xs={5}>
                <FormField
                    type="date"
                    name="folga"
                    label="Dia da folga"
                    required
                    InputProps={{
                        startAdornment: folga ? (
                            <span className="-mb-[18px]">
                                {dayjs.utc(folga).format('ddd')},&nbsp;
                            </span>
                        ) : null,
                    }}
                />
            </Grid>
            <Grid item xs={12}>
                <FormField
                    name="tabelaHorarioId"
                    select
                    label="Trocar tabela no dia de trabalho por"
                    placeholder="Tabela do dia de folga"
                    InputProps={{
                        endAdornment: tabelaHorarioId ? (
                            <IconButton className="mr-4" title="Remover">
                                <XIcon
                                    onClick={() =>
                                        setValue('tabelaHorarioId', null)
                                    }
                                />
                            </IconButton>
                        ) : null,
                    }}
                >
                    <Menu.Item value="">
                        <em>Tabela do dia de folga</em>
                    </Menu.Item>
                    {data.map(({ id, nome }) => (
                        <Menu.Item key={id} value={id}>
                            {nome}
                        </Menu.Item>
                    ))}
                </FormField>
            </Grid>
            <Grid item xs={12}>
                <Alert severity="info">
                    <span className="font-bold">Resumo da troca:</span>
                    <ul>
                        <li>
                            No dia{' '}
                            <b>
                                {trabalha
                                    ? dayjs
                                          .utc(trabalha)
                                          .format('DD/MM/YYYY')
                                          .concat(
                                              ' ' +
                                                  dayjs
                                                      .utc(trabalha)
                                                      .format('(dddd)'),
                                          )
                                    : 'ainda não definido'}
                            </b>{' '}
                            o funcionário irá trabalhar (em vez de folgar) e
                            cumprir a tabela{' '}
                            <b>
                                {tabelaHorarioId
                                    ? data.find(t => t.id === tabelaHorarioId)
                                          ?.nome || 'N/A'
                                    : 'originalmente do dia '.concat(
                                          folga
                                              ? dayjs
                                                    .utc(folga)
                                                    .format('DD [de] MMMM')
                                              : 'de folga',
                                      )}
                            </b>
                            .
                        </li>
                        <li>
                            No dia{' '}
                            <b>
                                {folga
                                    ? dayjs
                                          .utc(folga)
                                          .format('DD/MM/YYYY')
                                          .concat(
                                              ' ' +
                                                  dayjs
                                                      .utc(folga)
                                                      .format('(dddd)'),
                                          )
                                    : 'ainda não definido'}
                            </b>{' '}
                            o funcionário irá folgar (em vez de trabalhar).
                        </li>
                    </ul>
                </Alert>
            </Grid>
        </Grid>
    )
}
